// 有很多页面不知道属于那个模块的，暂时先放在这里


const rolePlatManage = () => import('@/components/platform/roleManage/roleManage')
const rolePlatAdd = () => import('@/components/platform/roleManage/addRole')
const platRoleDetail = () => import('@/components/platform/roleManage/roleDetail')
const platRoleModify = () => import('@/components/platform/roleManage/roleModify')
const loadPlatformUser = () => import('@/components/platform/loadPlatformUser/loadPlatformUser')
const addPlatUser = () => import('@/components/platform/loadPlatformUser/addPlatUser')
const platformCustomerSort = () => import('@/components/platform/loadPlatformUser/platformCustomerSort')

const addApply = () => import('@/components/platform/manage/addApply')
const manageAddress = () => import('@/components/platform/manageAddress/manageAddress')

// 平台-小程序管理
const appletManage = () => import('@/components/platform/applet/appletManage')
const applet = () => import('@/components/platform/applet/index')
// 平台-分类设置
const sortSetting = () => import('@/components/platform/sortSetting/index')
// 平台-菜单注册
const meauRegistration = () => import('@/components/platform/meauRegistration/meauRegistration')
const functionRegister = () => import('@/components/function/register');
// 组织机构
const deptTree = () => import('@/components/platform/dept/treePage')
const addEmployee = () => import('@/components/platform/dept/addEmployee')
const approval = () => import('@/components/platform/dept/approval')
const approvalDetail = () => import('@/components/platform/dept/approvalDetail')

// 证照资料
const customerLicense = () => import('@/components/platform/license/customerLicense')
//规则设置
const setRule = () => import('@/components/agreement/setRule')
const ruleAdd = () => import('@/components/agreement/ruleAdd')
const bussinessOrg = () => import('@/components/platform/bussiness/org/bussinessOrg')

const boxReimbursement = () => import( /* webpackChunkName: "reimbursement" */ '@/components/reimbursement/index');
const approval1 = () => import( /* webpackChunkName: "reimbursement" */ '@/components/reimbursement/approval/approval');
const statistics = () => import( /* webpackChunkName: "reimbursement" */
  '@/components/reimbursement/statistics/statistics');
const reimbursementProcess = () => import( /* webpackChunkName: "reimbursement" */
  '@/components/reimbursement/reimbursementProcess/index');
const setProcess = () => import( /* webpackChunkName: "reimbursement" */
  '@/components/reimbursement/reimbursementProcess/setProcess');
const reimbursementProcessManage = () => import( /* webpackChunkName: "reimbursement" */
  '@/components/reimbursement/reimbursementProcess/reimbursementProcess');

// 平台用户
const examineSet = () => import('@/components/platform/set/examineSet') //审批设置


export default [
  // 平台级
  {
    path: '/appletManage',
    name: 'appletManage',
    meta: {
      text: '小程序管理',
    },
    component: appletManage
  },
  // 平台 - 小程序管理
  {
    path: '/applet',
    component: applet,
    children: [{
        meta: {
          text: '应用管理',
        },
        path: "useManage",
        name: 'useManage',
        component: resolve => {
          require(['@//components/platform/applet/useManage.vue'],
            resolve)
        },
      },
      {
        meta: {
          text: '分类管理',
        },
        path: "classifyManage",
        name: 'classifyManage',
        component: resolve => {
          require(['@//components/platform/applet/classifyManage.vue'],
            resolve)
        },
      }
    ]
  },
  {
    path: '/platformRoleManage',
    name: 'rolePlatManage',
    meta: {
      text: '角色管理',
    },
    component: rolePlatManage
  },
  {
    path: '/functionRegister',
    meta: {
      text: '功能注册',
    },
    name: 'functionRegister',
    component: functionRegister
  },

  {
    path: '/dept/deptPage',
    name: 'deptTree',
    meta: {
      text: '组织机构',
    },
    component: deptTree
  },
  {
    path: '/dept/addEmployee',
    name: 'addEmployee',
    meta: {
      text: '添加员工',
    },
    component: addEmployee
  }, {
    path: '/depts/approval',
    name: 'approval',
    meta: {
      text: '审批员工',
    },
    component: approval
  }, {
    path: '/depts/approvalDetail',
    name: 'approvalDetail',
    meta: {
      text: '分配功能',
    },
    component: approvalDetail
  },
  {
    path: '/platformRoleManage/addRole',
    name: 'rolePlatAdd',
    meta: {
      text: '添加角色',
    },
    component: rolePlatAdd
  }, {
    path: '/platformRoleManage/roleDetail',
    name: 'platRoleDetail',
    meta: {
      text: '角色详情',
    },
    component: platRoleDetail
  }, {
    path: '/platformRoleManage/roleModify',
    name: 'platRoleModify',
    meta: {
      text: '修改角色信息',
    },
    component: platRoleModify
  }, {
    path: '/loadPlatformUser',
    name: 'loadPlatformUser',
    meta: {
      text: '平台用户管理',
    },
    component: loadPlatformUser
  }, {
    path: '/loadPlatformUser/addPlatUser',
    name: 'addPlatUser',
    meta: {
      text: '添加平台用户',
    },
    component: addPlatUser
  }, {
    path: '/platformCustomerSort',
    name: 'platformCustomerSort',
    meta: {
      text: '分类设置',
    },
    component: platformCustomerSort
  },
  {
    path: '/meauRegistration',
    name: 'meauRegistration',
    meta: {
      text: '菜单组设置',
    },
    component: meauRegistration
  },
  {
    path: '/sortSetting',
    name: 'sortSetting',
    meta: {
      text: '分类设置',
    },
    component: sortSetting
  },

  {
    path: '/addApply',
    meta: {
      text: '加入公司审核',
    },
    name: 'addApply',
    component: addApply
  },
  {
    path: '/manageAddress',
    meta: {
      text: '地区维护',
    },
    name: 'manageAddress',
    component: manageAddress
  },
  {
    path: '/customerLicense',
    name: 'customerLicense',
    meta: {
      text: '资料定义',
    },
    component: customerLicense
  },
  {
    path: '/setRule',
    name: 'setRule',
    meta: {
      belong: ['terrace'],
      text: '协议设置',
    },
    component: setRule,
  }, {
    path: '/ruleAdd',
    name: 'ruleAdd',
    meta: {
      belong: ['terrace'],
      text: '协议编辑',
    },
    component: ruleAdd,
  },
  {
    path: '/bussinessOrg',
    name: 'bussinessOrg',
    meta: {
      belong: ['terrace'],
      text: '平台组织',
    },
    component: bussinessOrg
  },

  {
    path: '/businessCenter/reimbursement/',
    component: boxReimbursement,
    children: [{
        path: 'approval',
        name: 'approval',
        meta: {
          belong: ['terrace'],
          text: '报销审批',
        },
        component: approval1,
      },
      {
        path: 'reimbursementProcess',
        name: 'reimbursementProcess',
        meta: {
          belong: ['terrace'],
          text: '报销流程',
        },
        component: reimbursementProcess,
      },
      {
        path: 'setProcess',
        name: 'setProcess',
        meta: {
          belong: ['terrace'],
          text: '设置流程',
        },
        component: setProcess,
      },
      {
        path: 'reimbursementProcessManage',
        name: 'reimbursementProcessManage',
        meta: {
          belong: ['terrace'],
          text: '流程管理',
        },
        component: reimbursementProcessManage,
      },

      {
        path: 'statistics',
        name: 'statistics',
        meta: {
          belong: ['terrace'],
          text: '报销统计',
        },
        component: statistics,
      },
    ]
  },
  {
    path: '/examineSet',
    name: 'examineSet',
    meta: {
      belong: ['terrace'],
      text: '审批设置',
    },
    component: examineSet,
  },


]
